import React from 'react';
import ProductService from '../services/product';
import $ from 'jquery';
import AuthorizationCheck from '../auth/authorizationCheck';
import { Modal } from 'react-bootstrap';

import Utility from '../utilities/utility';
import CountryService from '../services/country';
import ShippingService from '../services/shipping';
import UserService from '../services/user';
import OrderService from '../services/order';



class NonShippedProducts extends React.Component {

    constructor(props) {
        super(props);

        this.countryService = new CountryService();
        this.shippingService = new ShippingService();
        this.userService = new UserService();


        this.selectedShipment = localStorage.getItem('selectedShipment');

        this.state = {

            productList: [],
            currentUserRole: '',
            timeoutId: null,
            countries: [],
            shipment: [],
            showCustomerSearch: false,
            users: [],
            selectedUserId: null,
            removeOrderProductConfirmation: false
        }
    }

    componentDidMount() {

        this.countryList();
        this.fetchShipment();
    }


    countryList = async () => {

        try {
            const res = await this.countryService.fetchCountries();

            this.setState({
                countries: await res.json()
            });
        } catch (error) {
            console.log(error);
        }

    }


    fetchShipment = async () => {

        let selectedShipmentId = localStorage.getItem('selectedShipment');

        if (Utility.isEmpty(selectedShipmentId)) {

            return;
        }

        const response = await this.shippingService.findShipment(selectedShipmentId);

        this.setState({
            shipment: await response.json()
        });

    }


    shipmentBox = (shipment) => {

        let selectedShipmentId = localStorage.getItem('selectedShipment');

        if (Utility.isEmpty(selectedShipmentId)) {

            return 'No chargement choisi';
        }

        return <div className="shipment-wrapper mx-0" style={{ maxWidth: 400, textAlign: 'left' }} >

            <div className="card card-default mt-2 bg-info">

                <div className="card-body">
                    <div className="row">
                        <div ><span className="font-weight-bold">No Conteneur:</span> {shipment.containerId}</div>

                        <div>Description: {shipment.description}</div>

                        <div>Destination: {shipment.destinationCountry}</div>

                        <div>Date Depart: {shipment.shippingDate}</div>

                        <div>Date D'arrivée: {shipment.arrivalDate}</div>


                    </div>
                </div>

            </div>
        </div>

    }



    findProducts = async () => {

        $('#errorHolder').html(
            '<div class="alert alert-info load-alert mt-2">Veillez patienter pour le telechargement des données</div>'
        );

        let name = $('#name').val();
        let model = $('#model').val();
        let brand = $('#brand').val();
        let color = $('#color').val();
        let size = $('#size').val();
        let cpid = $('#cpid').val();
        let countryId = $('#countryId').val();
        let fromDate = $('#fromDate').val();
        let toDate = $('#toDate').val();

        let userId = sessionStorage.getItem("selectedUserId");

        console.log('state user: ' + userId);




        try {

            this.setState({

                productList: []
            });

            const response = await ProductService.nonShippedProducts(countryId, userId, name, model, brand, size, color, cpid, fromDate, toDate);

            if (response.ok) {

                $('.load-alert').delay(1000).fadeOut('fast');
            }


            this.setState({

                productList: await response.json()
            });



        } catch (error) {

            $('#errorHolder').html('');
            console.log(error);
        }

    }

    searchProduct = () => {

        let timer;

        clearTimeout(this.state.timeoutId);

        timer = setTimeout(() => {
            this.findProducts();
        }, 1500);

        this.setState({ timeoutId: timer })
    }

    setRole = (role) => {

        this.setState({ currentUserRole: role });
    }


    addToShipment = async (orderProductId, e) => {

        e.preventDefault();

        let quantity = $('#product-qty-' + orderProductId).val();


        if (quantity == 0 || Utility.isEmpty(this.selectedShipment)) {

            $('#order-product-row-' + orderProductId).before(
                '<div class="alert alert-danger order-product-row">Veillez revoir les paraetres requises</div>'
            );
            $('.order-product-row').delay(3000).fadeOut('slow');

            return;
        }

        try {

            const response = await this.shippingService.addProduct(this.selectedShipment, orderProductId, quantity);

            if (response.ok) {

                const addToShipmentResponse = await response.json();

                let orderQuantity = $('#remaining-quantity-' + orderProductId).html();

                let remainingQuantity = parseInt(orderQuantity) - parseInt(quantity);

                $('#remaining-quantity-' + orderProductId).html(remainingQuantity);

                $('#total-shipped-' + orderProductId).html(addToShipmentResponse.quantity);

                $('#product-qty-' + orderProductId).val('');


                $('#order-product-row-' + orderProductId).before(
                    '<div class="alert alert-success order-product-alert">Produit Ajouté</div>'
                );

                $('.order-product-alert').delay(3000).fadeOut('slow');
            } else {

                $('#order-product-row-' + orderProductId).before(
                    '<div class="alert alert-danger order-product-alert">Produit Non Chargé</div>'
                );

                $('.order-product-alert').delay(3000).fadeOut('slow');
            }



        } catch (error) {

            $('#order-product-row-' + orderProductId).before(
                '<div class="alert alert-danger order-product-alert">Produit non Ajouté</div>'
            );

            $('.order-product-alert').delay(3000).fadeOut('slow');
        }



    }


    exportProductsToExcel = (e) => {

        e.preventDefault();

        const productList = this.state.productList;

        const columns = [

            { label: "Nom", value: "name" }, // Top level data
            { label: "Modele", value: "model" }, // Custom format
            { label: "Marque", value: "brand" },
            { label: "Numero", value: "size" },
            { label: "Couleur", value: "color" },
            { label: "CPID", value: "supplierUniqueId" },
            { label: "Prix", value: "price" },
            { label: "Quantité", value: "nonShippedQuantity" },
            { label: "Quantité au Cargo", value: "stockQuantity" },
            { label: "Quantité Commandée", value: "quantity" },
            { label: "Quantité Servie", value: "pickedQuantity" },
            { label: "Quantité Chargée", value: "shippedQuantity" },
            { label: "CBM", value: "cbm" },
            { label: "Poids", value: "weight" },
            { label: "Quantité Par Carton", value: "quantityInBox" },
            { label: "Description", value: "orderDescription" },
        ];

        Utility.exportJsonToExcel("Produits Non Chargés", columns, productList);

    }


    findUsers = async () => {



        let name = $('#searchTerm').val();
        let countryId = $('#countryId').val();

        const response = await this.userService.userList(name, countryId);

        this.setState({

            users: await response.json()
        });
    }

    searchUsers = () => {

        let timer;

        clearTimeout(this.state.timeoutId);

        timer = setTimeout(() => {
            this.findUsers();
        }, 1500);

        this.setState({ timeoutId: timer })
    }

    hideCustomerSearchForm = () => {

        this.setState({ showCustomerSearch: false });
    }

    showCustomerSearchForm = () => {

        this.setState({ showCustomerSearch: true });
    }

    selectUser = (userId, name, e) => {

        e.preventDefault();

        //console.log('user: '+userId);

        sessionStorage.setItem("selectedUserId", userId);

        $('#selected-user-details').html(
            '<div class="alert alert-info mb-2">Selectionner: ' + name + '</div>'
        )

        this.setState({

            showCustomerSearch: false
        });

        $('#searchTerm').blur();

        this.findProducts();

    }

    removeNonShippedProduct = async () => {

        let productId = sessionStorage.getItem('removeOrderProductId');

        let quantity = sessionStorage.getItem('removeOrderProductQty');

        const response = await OrderService.removeNonShippedOrderProduct(productId, quantity);

        if (response.ok) {

            sessionStorage.removeItem('removeOrderProductId');

            sessionStorage.removeItem('removeOrderProductQty');

            $('#order-product-row-' + productId).remove();

            this.hideConfirmationForm();


        }

    }

    hideConfirmationForm = () => {

        this.setState({

            removeOrderProductConfirmation: false
        });
    }

    showRemoveConfirmationForm = (productId, quantity, e) => {

        e.preventDefault();

        sessionStorage.setItem('removeOrderProductId', productId);

        sessionStorage.setItem('removeOrderProductQty', quantity);

        this.setState({

            removeOrderProductConfirmation: true
        });
    }



    render() {



        const productList = this.state.productList;

        const countries = this.state.countries;

        const shipment = this.state.shipment;

        let shipmentBox = this.shipmentBox(shipment);

        let countrySelection = '';

        if (this.state.currentUserRole == 'MANAGER' || this.state.currentUserRole == 'SUPER-ADMIN') {


            countrySelection = <div className="row">
                <div className="col-md-12">
                    <div className="form-group">
                        <label className="label">Choisi le Pays</label>
                        <select className="form-control" id="countryId" onChange={this.findProducts} >
                            <option></option>
                            {countries.length > 0 && countries.map(country =>

                                <option key={country.countryId} value={country.countryId}>{country.name}</option>
                            )}
                        </select>
                    </div>
                </div>
            </div>
        }

        const users = this.state.users;

        return (


            <div className="container">

                <AuthorizationCheck accessLevel='MANAGER' userRole={this.setRole} />

                <Modal show={this.state.showCustomerSearch}>
                    <Modal.Header closeButton onHide={this.hideCustomerSearchForm}>Rechercher</Modal.Header>
                    <Modal.Body>

                        <div className='form-group'>
                            <input className="form-control" id="searchTerm" placeholder="Entrer le nom" onKeyUp={this.searchUsers} />
                        </div>

                        {users == null || users.length == 0 ? "Non Trouvé": ""}

                        {users != null && users.length > 0 && users.map(user =>

                            <div className='card'>
                                <div className='card-body'>
                                    <div className='row'>
                                        <div className='col'>{user.name}</div>
                                        <div className='col'>
                                            <button className='btn btn-primary full-width' onClick={(e) => this.selectUser(user.userId, user.name, e)}>Choisissez</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}


                    </Modal.Body>

                </Modal>


                <Modal show={this.state.removeOrderProductConfirmation}>
                    <Modal.Header closeButton onHide={this.hideConfirmationForm}>Supprimer</Modal.Header>
                    <Modal.Body>

                        <p>Voulez vous supprimer la quantité non chargée?</p>

                        <div className='form-group'>
                            <button className="btn btn-danger full-width" onClick={this.removeNonShippedProduct}>Supprimer</button>
                        </div>




                    </Modal.Body>

                </Modal>





                <div className="supplier-wrapper mt-4">

                    <h2 className="text-center">List de Produits Non Chargés</h2>




                    <div className="form-wrapper">

                        {countrySelection}

                        <div className="row">
                            <div className="col">


                                <div className="form-group">
                                    <input className="form-control" id="name" placeholder="Nom" onKeyUp={this.searchProduct} />
                                </div>
                            </div>
                            <div className="col">
                                <div className="form-group">
                                    <input className="form-control" id="model" placeholder="Model" onKeyUp={this.searchProduct} />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col">

                                <div className="form-group">
                                    <input className="form-control" id="brand" placeholder="Marque" onKeyUp={this.searchProduct} />
                                </div>
                            </div>
                            <div className="col">
                                <div className="form-group">
                                    <input className="form-control" id="size" placeholder="Numero" onKeyUp={this.searchProduct} />
                                </div>
                            </div>

                            <div className="col">
                                <div className="form-group">
                                    <input className="form-control" id="cpid" placeholder="CPID" onKeyUp={this.searchProduct} />
                                </div>
                            </div>
                        </div>

                        <div className="row">

                            <div className="col-md-12">

                                <div id='selected-user-details'></div>

                                <div className="form-group">

                                    <input className="form-control" placeholder="Entrer le nom" onClick={this.showCustomerSearchForm} />
                                </div>

                                
                            </div>



                        </div>





                    </div>

                    {shipmentBox}

                    <div className="card card-default mt-2 bg-primary text-white">



                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-3">Description</div>



                                <div className="col">Quantité</div>
                                <div className="col"></div>
                                <div className="col">

                                    <button className='btn btn-light full-width' onClick={(e) => this.exportProductsToExcel(e)}>Exporter</button>

                                </div>


                            </div>
                        </div>

                    </div>

                    <div id='errorHolder'></div>

                    {productList.length > 0 && productList.map(product => {



                        return <div className="card card-default mt-2" key={product.id}>

                            <div className="card-body">
                                <div className="row" id={'order-product-row-' + product.id}>
                                    <div className="col-md-3">
                                        <div>{product.name} {product.model} {product.brand} {product.color} {product.size}</div>
                                        <div className='fw-bold'>CPID: {product.supplierUniqueId}</div>
                                        <div className='fw-bold text-primary'>PRIX: {product.price}</div>
                                    </div>


                                    <div className="col"><span id={'remaining-quantity-' + product.id}>{product.nonShippedQuantity}</span></div>

                                    <div className='col'>
                                        <div>
                                            <a href={'/orderProducts?orderId=' + product.orderId}><div className='full-width text-start'>{product.orderDescription}</div></a>
                                        </div>
                                        <div className='text-start'>Quantité Chargée: <span id={'total-shipped-' + product.id}>{product.shippedQuantity}</span> </div>
                                        <div className='text-start'>Quantité Servie: {product.pickedQuantity}</div>
                                        <div className='text-start'>Quantité au cargo: {product.stockQuantity}</div>
                                        <div className='text-start'>Quantité Commandée: {product.quantity}</div>
                                    </div>

                                    <div className='col'>
                                        <div className='form-group'>
                                            <input className='form-control' id={'product-qty-' + product.id} placeholder='Quantité desirée' />
                                        </div>

                                        <div className='form-group'>
                                            <button className='btn btn-primary full-width' onClick={(e) => this.addToShipment(product.id, e)}>Ajoute au chargement</button>
                                            <button className='btn btn-danger full-width mt-2' onClick={(e) => this.showRemoveConfirmationForm(product.id, product.nonShippedQuantity, e)}>Supprimer</button>

                                        </div>



                                    </div>

                                </div>
                            </div>

                        </div>


                    })}

                </div>
            </div>



        );


    }
}

export default NonShippedProducts;